import { $httpAdmin } from "../../api/http";
import { URL_ADMIN } from '../../api/url';
import { type AxiosPromise } from "../../modules/axios";

export * from './application';
export * from './banner';
export * from './custom';
export * from './logo';
export * from './nav';
export * from './news';
export * from './product';
export * from './user';

/**
 * 上传
 */
export function apiFileUpload(file: Blob): AxiosPromise<string> {
  const fd = new FormData();
  fd.append("filepdf", file);
  return $httpAdmin.post("/products/file", fd);
}

export function apiFileGetUrl(filename: string) {
  return `${URL_ADMIN}/products/fslehx?filename=${filename}`;
}

/**
 * 下载
 */
export function apiFileGet(
  filename: string
): AxiosPromise<Blob> {
  return $httpAdmin.get(apiFileGetUrl(filename), {
    responseType: "blob",
  });
}

export function apiFileDelete(
  fileUrl: string
): AxiosPromise {
  return $httpAdmin.get('/products/delete', { params: { fileUrl } });
}
